module.exports = __webpack_public_path__ + "img/Registro.86d9cf8f.png";